import { useEffect, useMemo, useState } from 'react';
import { useLayer } from 'react-laag';
import type { Options } from 'react-laag/dist/types';
import type { UseLayerProps } from 'react-laag';

/**
 * Simple wrapper hook around {@link useLayer}, to prevent a short flashing from the layer on the wrong position.
 *
 * https://github.com/everweij/react-laag/issues/91
 *
 * @param options check {@link Options}
 * @returns options check {@link UseLayerProps}
 */
export function useLayerDeferedVisibility(options: Options): UseLayerProps {
  const [firstRender, setFirstRender] = useState(true);

  const result = useLayer(options);

  useEffect(() => {
    if (options.isOpen) {
      setFirstRender(false);
    }

    return () => setFirstRender(true);
  }, [options.isOpen]);

  return useMemo(() => {
    if (firstRender) {
      result.layerProps.style = { ...result.layerProps.style, opacity: 0.0 };
    }
    return result;
  }, [result, firstRender]);
}
